import { PLAN_MANAGEMENT_V2 } from '../../../../paths'

export const PLAN_AND_RATE_OVERRIDES = `/${PLAN_MANAGEMENT_V2}/overrides/plans-rates`

export const planAndRateOverridesPath = (subtab?: string) =>
  subtab
    ? `${PLAN_AND_RATE_OVERRIDES}/${subtab.toLowerCase()}`
    : `${PLAN_AND_RATE_OVERRIDES}/inactive`
